'use strict';

var callDateSet = require('../../common/internal/callDateSet');

function setYear(d, val) {
  callDateSet(d, 'FullYear', val);
}

module.exports = setYear;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/setYear.js
// module id = 225
// module chunks = 1